export default "__VITE_ASSET__DWZzgr9W__"